module.exports = __webpack_public_path__ + "img/risk_img3.ef67980f.png";